/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAreaItemIdGet } from '../fn/area/api-area-item-id-get';
import { ApiAreaItemIdGet$Params } from '../fn/area/api-area-item-id-get';
import { apiAreaOverviewGet } from '../fn/area/api-area-overview-get';
import { ApiAreaOverviewGet$Params } from '../fn/area/api-area-overview-get';
import { apiAreaSyncPost } from '../fn/area/api-area-sync-post';
import { ApiAreaSyncPost$Params } from '../fn/area/api-area-sync-post';
import { Area } from '../models/area';
import { AreaOverviewList } from '../models/area-overview-list';


/**
 * Area service
 */
@Injectable({ providedIn: 'root' })
export class AreaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAreaSyncPost()` */
  static readonly ApiAreaSyncPostPath = '/api/area/sync';

  /**
   * Sync areas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAreaSyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiAreaSyncPost$Response(params: ApiAreaSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAreaSyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync areas.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAreaSyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiAreaSyncPost(params: ApiAreaSyncPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAreaSyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAreaItemIdGet()` */
  static readonly ApiAreaItemIdGetPath = '/api/area/{item_id}';

  /**
   * Get an area.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAreaItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAreaItemIdGet$Response(params: ApiAreaItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Area>> {
    return apiAreaItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an area.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAreaItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAreaItemIdGet(params: ApiAreaItemIdGet$Params, context?: HttpContext): Observable<Area> {
    return this.apiAreaItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Area>): Area => r.body)
    );
  }

  /** Path part for operation `apiAreaOverviewGet()` */
  static readonly ApiAreaOverviewGetPath = '/api/area/overview';

  /**
   * Get area overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAreaOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAreaOverviewGet$Response(params?: ApiAreaOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaOverviewList>> {
    return apiAreaOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get area overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAreaOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAreaOverviewGet(params?: ApiAreaOverviewGet$Params, context?: HttpContext): Observable<AreaOverviewList> {
    return this.apiAreaOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AreaOverviewList>): AreaOverviewList => r.body)
    );
  }

}
